import { render, staticRenderFns } from "./MyNews3.vue?vue&type=template&id=8e84052a&scoped=true"
import script from "./MyNews3.vue?vue&type=script&lang=js"
export * from "./MyNews3.vue?vue&type=script&lang=js"
import style0 from "./MyNews3.vue?vue&type=style&index=0&id=8e84052a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e84052a",
  null
  
)

export default component.exports